export const LOGIN_CONST = {
    ACCESS_TOKEN: "accessToken",
    REFRESH_TOKEN: "refreshToken",
    LEFT_ARROW: "LEFT_ARROW",
    RIGHT_ARROW: "RIGHT_ARROW",
    RADIO_BUTTON: "RADIO_BUTTON",
    EMAIL: "email",
    PASSWORD: "password"
}